import { WeekDayEnum } from "@/enum";
import { z } from "zod";

export const CreateWorkingHourFormSchema = z.object({
  open_at: z.string().regex(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/, {
    message: "Horário de abertura inválido",
  }),
  close_at: z.string().regex(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/, {
    message: "Horário de fechamento inválido",
  }),
  week_day: z
    .string()
    .refine(
      (value) => WeekDayEnum[value as keyof typeof WeekDayEnum] !== undefined,
      { message: "Dia da semana inválido" },
    ),
});
